const STRONG_TAG = /<strong>(.*?)<\/strong>/;

export type StrongSegment = {
  id: number;
  isStrong: boolean;
  text: string;
};

export const splitStrongSegments = (text: string): StrongSegment[] =>
  text
    .split(STRONG_TAG)
    .flatMap((part, index) =>
      part === '' ? [] : [{ id: index, isStrong: index % 2 === 1, text: part }],
    );
